import React, { Fragment } from 'react';
import image from '../../../assets/images/expired.jpg';
import ErrorUi from '../../../components/user-interfaces/error/error.ui';

/**
 * Composant de la page d'expiration
 * @constructor
 */
export default function ExpiredPage() {
    return (
        <Fragment>
            <ErrorUi img={image} title="Oups..." msg="Le lien n'est plus disponible, merci de refaire votre demande." />
        </Fragment>
    );
}
